var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhatsNewMain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83,
    height: 83,
    viewBox: "0 0 83 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3555_282596)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.8924 42.2269L10.7733 39.9492C3.84301 42.6638 1.15378 50.5666 4.92124 56.9571C7.21865 61.8733 13.2145 64.5301 18.4055 62.936C19.3836 62.678 20.4548 62.1086 21.3696 61.6632C21.0989 61.1432 12.4858 43.4404 11.8924 42.2255V42.2269Z",
    fill: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.147 48.2968C71.1104 47.7753 70.961 47.2651 70.7397 46.7957H70.727L52.3336 9.06328C51.9827 8.32331 51.409 7.70597 50.7311 7.26904C46.958 4.87015 42.373 8.92656 44.3322 12.9689L44.6 13.5284C39.6204 19.8188 34.3152 26.5842 27.7951 31.4017C26.6675 32.425 14.6407 37.981 13.0635 38.8309C14.6562 42.0473 22.0671 57.3286 23.6597 60.5463C26.3673 59.2426 31.1975 56.8733 33.9516 55.5343C35.1087 54.9804 36.7832 54.084 38.0221 53.702C46.0418 51.2961 54.7988 51.3483 63.0708 51.2722C63.7544 52.2898 64.8919 52.9423 66.0857 53.1425C66.0152 53.1298 65.9419 53.1073 65.87 53.0918C68.7707 53.7176 71.481 51.2285 71.1498 48.2954L71.147 48.2968Z",
    fill: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3592 56.7051C34.6305 58.0412 29.7961 60.3936 27.0674 61.7298L33.1985 74.2979C33.6439 75.214 34.4191 75.9004 35.386 76.2316C36.3486 76.5671 37.3775 76.5149 38.2993 76.054L41.7341 74.3881C42.6503 73.9427 43.3367 73.1675 43.6679 72.2006C43.9991 71.2337 43.9357 70.2034 43.4903 69.2873L37.3592 56.7065V56.7051Z",
    fill: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.9625 26.2542C65.2712 26.8913 66.0449 27.145 66.6637 26.8406L74.6666 22.9364C75.298 22.6277 75.5602 21.8666 75.2515 21.2352C74.9442 20.6052 74.1888 20.3416 73.5503 20.6489L65.5474 24.553C64.916 24.8617 64.6538 25.6228 64.9625 26.2542Z",
    fill: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.0998 17.6998C61.72 17.9972 62.4924 17.735 62.7926 17.0937L66.2781 9.73214C66.5798 9.09789 66.3077 8.33819 65.6735 8.03798C65.0421 7.73777 64.2824 8.00838 63.9807 8.64405L60.4952 16.0056C60.1935 16.6399 60.4656 17.3996 61.0998 17.6998Z",
    fill: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.7916 35.3868L70.8451 33.6011C69.189 33.2952 68.6548 35.649 70.2884 36.0831L78.2349 37.8689C78.9016 38.0239 79.6035 37.5968 79.7543 36.9062C79.9079 36.2198 79.4766 35.5405 78.7916 35.3868Z",
    fill: "#4A4A4A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3555_282596"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 76.5741,
    height: 69.8947,
    fill: "white",
    transform: "translate(3.21289 6.55273)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsNewMain);
export default __webpack_public_path__ + "static/media/Whats_New_Main.6b645bd5b4ee8bf877aaf646565227af.svg";
export { ForwardRef as ReactComponent };